import "@babel/polyfill";
import './tailwind.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './data/store';
import * as Sentry from '@sentry/react';

import { BrowserRouter, Switch, Route } from 'react-router-dom';

import AlertsWrapper from 'Components/AlertsWrapper';

import AppRoute from './routes/AppRoute';
import SetupRoute from './routes/SetupRoute';
import PrivateRoute from './routes/PrivateRoute';

import LoginController from 'Controllers/LoginController';
import AccountsController from 'Controllers/AccountsController';
import FacebookController from 'Controllers/FacebookController';
import InviteController from 'Controllers/InviteController';
import SignupController from "Controllers/SignupController";

import TestController from 'Controllers/TestController';

Sentry.init({
    dsn: process.env.SENTRY_WEBAPP_DSN,
    environment: process.env.NODE_ENV
});

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <SetupRoute>
                <Switch>
                    <Route path="/test" component={TestController} />

                    <Route path="/login" component={LoginController} />
                    <Route path="/signup" component={SignupController} />

                    <Route exact path="/invite/:token" component={InviteController} />
                    <Route exact path="/facebook/callback" component={FacebookController} />

                    <PrivateRoute path="/accounts" component={AccountsController} />

                    <PrivateRoute path="/" component={AppRoute} />
                </Switch>
            </SetupRoute>
        </BrowserRouter>
        <AlertsWrapper />
    </Provider>,
    document.getElementById('root')
);
